import React from "react";
import Modal from "react-bootstrap/Modal";
import Nodata from "../../component/common-component/Nodata";

const CommentModal = (props) => {
    return (
        <Modal
            {...props}
            size={"lg"}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            scrollable
            className="rejected-comment-modal"
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Rejected Comment
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
               
            </Modal.Body>
            <Modal.Footer>
                <button className="grey-btn w-auto" type="reset" onClick={props.onHide}>
                    Close
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default CommentModal;
